
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"data-name":"Icon awesome-crown","d":"M52.8 51.21H11.2a1.6 1.6 0 00-1.6 1.6V56a1.6 1.6 0 001.6 1.6h41.6a1.6 1.6 0 001.6-1.6v-3.2a1.6 1.6 0 00-1.6-1.59zm6.4-32A4.8 4.8 0 0054.4 24a4.69 4.69 0 00.44 2l-7.24 4.33a3.18 3.18 0 01-4.38-1.1v-.06L35 14.91a4.8 4.8 0 10-6.75-.69 5.62 5.62 0 00.69.69l-8.12 14.26a3.2 3.2 0 01-4.36 1.2h-.06L9.17 26a4.79 4.79 0 10-4.37 2.81 4.9 4.9 0 00.77-.08L12.8 48h38.4l7.23-19.28a3.94 3.94 0 00.77.08 4.8 4.8 0 000-9.6z"}})])
          )
        }
      }
    